// extracted by mini-css-extract-plugin
module.exports = {"Paper":"SelectFarmMenu_Paper__Cw_8I","Search":"SelectFarmMenu_Search__1NCWj","narrow-scrollbar":"SelectFarmMenu_narrow-scrollbar__nWF6J"};